<script setup>
import {
  NUMBER_INPUT_DIGITS,
  NUMBER_INPUT_FRACTIONS
} from '@/utils/components-configurations/app-input-number'

import AppInputNumberNext from '@/components/ui/AppInputNumberNext/AppInputNumberNext'

defineOptions({
  name: 'ProgressPreviewValueField'
})

defineProps({
  label: {
    type: String,
    default: ''
  },

  suffix: {
    type: String,
    default: ''
  },

  prefix: {
    type: String,
    default: ''
  },

  readonly: {
    type: Boolean,
    default: true
  }
})

const model = defineModel({
  type: [Number, String],
  required: true
})
</script>

<template>
  <AppInputNumberNext
    v-model="model"
    :digit-max-length="NUMBER_INPUT_DIGITS.ELEMENT_VALUES"
    :fraction="NUMBER_INPUT_FRACTIONS.ELEMENT_VALUES"
    :label
    :prefix
    :readonly
    :suffix
    allow-negative
    full-width
  />
</template>

<style lang="scss" scoped></style>
